<div class="bloco-card-small">

  <div class="title-with-icon">
    <mat-icon>search</mat-icon>
    <h3 class="bloco-title">Pesquisa Sob Encomenda</h3>
  </div>

  <p class="bloco-desc">
    Não encontrou o que precisava? Peça para nossa equipe pesquisar
    uma obra específica para você.
  </p>

  <button class="solicitar-btn" (click)="abrirModal()" type="button">
    SOLICITAR PESQUISA
  </button>
</div>

@if (showModal) {
  <app-modal-solicitar-nova-obra
    (close)="fecharModal()"
    (loading)="onModalLoading($event)"
  ></app-modal-solicitar-nova-obra>
}